import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomLeft from '../view/FJVideoRemoveBgCustomLeft';
import { useSelector } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJVideoRemoveBgCustomRemoverAfterContainer from './FJVideoRemoveBgCustomRemoverAfterContainer';
import { VIDEO_REMOVE_BG_USE_CREDIT } from '../../../../redux/slices/FJSliceVideoBgRemover';
import FJVideoRemoveBgCustomExportContainer from './FJVideoRemoveBgCustomExportContainer';
import FJConstant from '../../../../constants/FJConstant';
import PropTypes from 'prop-types';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJVideoRemoveBgCustomLeftContainer = memo(({ isShow }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const editVideoInfo = useSelector(state => state.videoBgRemover.editVideoInfo);
    const curMenuIndex = useSelector(state => state.videoBgRemover.curMenuIndex);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const hasPointLoading = useSelector(state => state.videoBgRemover.hasPointLoading);
    const customRemoverStep = useSelector(state => state.videoBgRemover.customRemoverStep);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);
    const isTrimVideo = useSelector(state => state.videoBgRemover.customRemoverIsTrimVideo);
    const totalTime = useSelector(state => state.videoBgRemover.totalTime);
    const customExportStatus = useSelector(state => state.videoBgRemover.customExportData.exportStatus);
    const customIsUploading = useSelector(state => state.videoBgRemover.customIsUploading);
    const videoBackgroundRemoveFreeNum = useSelector(state => state.videoBgRemover.videoBackgroundRemoveFreeNum);

    const creditNumber = useSelector(state => state.common.creditNumber);
    const useCredit = totalTime ? (Math.floor(totalTime) * VIDEO_REMOVE_BG_USE_CREDIT).toFixed(1) : 0;
    const canCredit = creditNumber >= useCredit;
    const isFree = !canCredit && videoBackgroundRemoveFreeNum > 0;

    const _uploadVideo = useCallback(
        file => {
            if (hasPointLoading) return;
            dispatch(FJActionVideoRemoveBg.uploadCustomVideoAction(file));
        },
        [dispatch, hasPointLoading],
    );

    const _onGenerate = useCallback(() => {
        if (hasPointLoading) return;
        dispatch(FJActionVideoRemoveBg.startTrackAction());
    }, [dispatch, hasPointLoading]);

    const _onRemoveAll = useCallback(() => {
        if (hasPointLoading) return;
        dispatch(FJActionVideoRemoveBg.removeAllAction());
    }, [dispatch, hasPointLoading]);

    const _uploadBeforeCallback = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    return (
        <>
            {customRemoverStep === 0 && (
                <FJVideoRemoveBgCustomLeft
                    uploadVideo={_uploadVideo}
                    onGenerate={_onGenerate}
                    onRemoveAll={_onRemoveAll}
                    uploadBeforeCallback={_uploadBeforeCallback}
                    hasPointLoading={hasPointLoading}
                    customRemoverStatus={customRemoverStatus}
                    isTrimVideo={isTrimVideo}
                    isFree={isFree}
                    useCredit={Number(useCredit)}
                    freeNumCreation={videoBackgroundRemoveFreeNum}
                    editVideoInfo={editVideoInfo}
                    isShow={isShow}
                    isProjectLoading={isProjectLoading}
                    customIsUploading={customIsUploading}
                />
            )}

            {customRemoverStep === 1 && (
                <>
                    <FJVideoRemoveBgCustomRemoverAfterContainer isShow={isShow} />
                    {customExportStatus !== FJConstant.DEFAULT && curMenuIndex === 1 && (
                        <FJVideoRemoveBgCustomExportContainer />
                    )}
                </>
            )}
        </>
    );
});

FJVideoRemoveBgCustomLeftContainer.displayName = 'FJVideoRemoveBgCustomLeftContainer';

FJVideoRemoveBgCustomLeftContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJVideoRemoveBgCustomLeftContainer;
